import React, { Fragment } from 'react'
import { createGlobalStyle } from 'styled-components'
import { Normalize } from 'styled-normalize'

const GlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font-family: Montserrat, sans-serif;
    color: ${props => props.theme.colors.text};
    font-size: ${props => props.theme.fontSizes.normal};
  }

  a {
    color: ${props => props.theme.colors.primary};

    &:hover {
      color: ${props => props.theme.colors.darkenPrimary};
    }
  }

  .sep {
    border-top: 2px ${props => props.theme.colors.border} dashed;
    margin: 15px -15px;
    opacity: 0.3;
  }
`;

function Reset(){
  return (
    <Fragment>
      <Normalize />
      <GlobalStyles />
    </Fragment>
  )
}

export default Reset;
